import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        // Clean the URL fragment then route to the right home
        window.history.replaceState(null, "", window.location.pathname);
        const target = roleHome(data?.role);
        navigate(target, { replace: true });
      } catch {
        navigate("/login", { replace: true, state: { error: "Google sign-in failed. Please try again." } });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center reveal">
        <div className="overline mb-3">Arogya Pramana</div>
        <h1 className="text-3xl font-serif font-medium">Verifying your session…</h1>
        <p className="text-muted-foreground mt-2">Securely establishing your trust profile.</p>
      </div>
    </div>
  );
}

function roleHome(role) {
  switch (role) {
    case "doctor":
      return "/doctor";
    case "hospital":
      return "/hospital";
    case "admin":
      return "/admin";
    default:
      return "/patient";
  }
}
